// extracted by mini-css-extract-plugin
module.exports = {"Overlay":"popup_Overlay__Td6qD","Popup":"popup_Popup__3oJ-o"};